import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addSubTasks, updateSubTasks } from '../../actions/userActions/subTaskAction'
import Loader from '../subComponents/Loader'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodySmallRegular from '../designSystem/BodySmallRegular';
import subtaskIcon from "../../assets/images/subtaskIcon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { IconButton } from '@mui/material';
import { validateFields } from '../../utils/Validations';
import Textarea from '../designSystem/TextArea';
import TextField from '../designSystem/TextField';
function AddSubTasks({ onClose, editData, onSave} ) {

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const initialValues = { name: "", description: "", active: false };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
useEffect(() => {
    if (editData) {
        setFormValues(editData);
    }
}, [editData]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSave = (e) => {
    e.preventDefault();
    const errors =validateFields(formValues, 'subtask');
    setFormErrors(errors);
  
    if (Object.keys(errors).length === 0) {
      if (editData) {
        // Ensure the correct status is maintained when saving
        const updatedSubTask = {
          ...formValues,
          status: formValues.active ? "Active" : "Inactive", // Make sure status is set on save
        };
        dispatch(updateSubTasks(updatedSubTask)); 
      } else {
        dispatch(addSubTasks(formValues));
      }
      onSave(formValues); // Save the task
    }
  };
  const validate = (values) => {
    const errors = {};
  
    if (!values.name) {
      errors.name = REQUIRED_MESSAGE("Name");
    } else if (values.name.length > MAX_NAME_LENGTH) {
      errors.name = MAX_LENGTH_MESSAGE("Name", MAX_NAME_LENGTH);
    }
  
    if (!values.description) {
      errors.description = REQUIRED_MESSAGE("Description");
    } else if (values.description.length > MAX_DESCRIPTION_LENGTH) {
      errors.description = MAX_LENGTH_MESSAGE("Description", MAX_DESCRIPTION_LENGTH);
    }
  
    return errors;
  };
  

    return (
        <>
         <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container">
        <div className="dynamicmodal-header mb-3">
          <div className="dynamicmodal-header-left">
            <div className="icon">
              <img src={subtaskIcon} alt="subtasks" />
            </div>
            <div className="text">
              <BodyLargeMedium
                text={editData ? "Edit SubTasks" : "Add SubTasks"}
                color="#384153"
              />
              <p>Create a smaller, manageable task within a larger task.</p>
            </div>
          </div>
          <div className="dynamicmodal-header-right">
          <IconButton onClick={onClose}>
            <img src={closeModal} alt="" />
            </IconButton>
          </div>
        </div>
       

        <form onSubmit={handleSave}>
          <div className="dynamicmodal-body">
         
          <TextField
              name="name"
              label="Name"
              type="text"
              value={formValues.name}
              onChange={handleChange}
              placeholder="Enter name"
              error={formErrors.name}
            />
            <Textarea
              name="description"
              label="Description"
              placeholder="Enter your description here"
              value={formValues.description}
              onChange={handleChange}
              error={formErrors.description}
            />

            <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div  style={{  padding :'2px'}}>
                    <BodyExtraSmallMedium text="Active ?" color="#1E293B" />
                    </div>
  </label>
                </div>
              </div>
          </div>

          <div className="dynamicmodal-footer">
            <button
              className="cancel-button"
              type="button"
              onClick={onClose}
            >
              <BodyExtraSmallMedium color="#1E293B" text="Cancel" />
            </button>
            <button
              type="submit"
              className="primary-button"
              disabled={false}
            >
              <BodyExtraSmallMedium color="#FFFFFF" text="Save" />
            </button>
          </div>
        </form>
      </div>
    </div>
        </>
    )
}

export default AddSubTasks
